document.addEventListener('DOMContentLoaded', () => {

    const faqPage = document.querySelector('.post-type-archive-faqs')
    const faqTemplate = document.querySelector('.page-template-template-faq')

    if (faqPage !== null || faqTemplate !== null) {

        const cancelSearch = document.querySelector('.js-cancel-search')

        document.querySelector('.js-faqs-search').addEventListener('submit', function (e) {
            e.preventDefault()
            const value = this.querySelector('input').value.toLowerCase()
            cancelSearch.classList.add('active')

            document.querySelectorAll('.c-accordion-grid__item__btn').forEach(function (gridItemBtn) {
                gridItemBtn.classList.remove('is-hidden')

                const title = gridItemBtn.querySelector('.js-title').textContent.toLowerCase()
                const parentFaqItem = gridItemBtn.querySelector('.js-title').closest('.js-faq-item')
                const answer = parentFaqItem.querySelector('.js-answer p').textContent.toLowerCase()

                if (!title.includes(value) && !answer.includes(value)) {
                    parentFaqItem.classList.add('is-hidden')
                }
            })

            mapFaqCategories()
        })

        const mapFaqCategories = () => {
            document.querySelectorAll('.c-accordion-grid').forEach(function (faqSection) {
                faqSection.classList.remove('is-hidden')
                const hiddenLength = faqSection.querySelectorAll('.js-faq-item.is-hidden').length

                if (hiddenLength > 0 && hiddenLength === faqSection.querySelectorAll('.js-faq-item').length) {
                    faqSection.classList.add('is-hidden')
                }
            })
        }

        const submitButton = document.querySelector('.js-faq-submit')

        submitButton.addEventListener('click', function () {
            const faqSearchForm = document.querySelector('.js-faqs-search')
            const submitEvent = new SubmitEvent('submit', {submitter: submitButton, cancelable: true})

            faqSearchForm.dispatchEvent(submitEvent)
        })

        cancelSearch.addEventListener('click', function () {
            document.querySelectorAll('*').forEach(function (e) {
                e.classList.remove('is-hidden')
                const searchBar = document.querySelector('.js-faqs-search')
                searchBar.querySelector('input').value = ''
                cancelSearch.classList.remove('active')
            })
        })

        handleHashChange();

        fillSearch();
    }

    window.addEventListener('hashchange', handleHashChange);
})

function handleHashChange() {
    const currentUrl = window.location.hash;
    const classSelector = currentUrl.replace('#', '.');

    document.querySelectorAll('.active').forEach(function(activeItem) {
        activeItem.classList.remove('active');
    });

    if (currentUrl) {
        document.querySelectorAll(classSelector).forEach(function(faqActive) {
            faqActive.classList.add("active");
        });
    }
}

function fillSearch() {
    const faqsSearchInput = document.querySelector('.js-faqs-search input');

    if (faqsSearchInput) {
        const savedSearchTerm = sessionStorage.getItem('faqSearchTerm');

        if (savedSearchTerm) {
            faqsSearchInput.value = savedSearchTerm;

            faqsSearchInput.dispatchEvent(new Event('input'));

            const searchForm = document.querySelector('.js-faqs-search');
            if (searchForm) {
                const submitEvent = new Event('submit', {
                    bubbles: true,
                    cancelable: true
                });

                searchForm.dispatchEvent(submitEvent);
            }

            sessionStorage.removeItem('faqSearchTerm');
        }
    }
}




